import React, { useEffect, useState } from 'react';
import './NotificationToast.css';

const NotificationToast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✨';
      case 'celebration':
        return '🎉';
      case 'streak':
        return '🔥';
      default:
        return '✨';
    }
  };

  return (
    <div className={`notification-toast ${type} ${isVisible ? 'visible' : 'hidden'}`}>
      <span className="toast-icon">{getIcon()}</span>
      <span className="toast-message">{message}</span>
    </div>
  );
};

export default NotificationToast;
